jQuery( document ).ready( function( $ ) {
  /**
  * Sets grid dropdown widths.
  */
  // Disabled 2/12/21 - is this being used anywhere?
  // function pdSetGridDropdownWidth( resize ) {
  //   $( '.pd-dropdown-grid' ).each( function() {
  //     let el = $( this );
  //     let cols = el.children().children();
  //     if ( resize === false && cols.length ) {
  //       el.css( 'width', ( el.width() * cols.length ) + 'px' );
  //     }
  //     if ( el.hasClass( 'dropdown-menu-right' ) ) {
  //       el.css( 'max-width', Math.floor( ( el.parent().offset().left + el.parent().outerWidth() ) ) + 'px' );
  //     } else {
  //       el.css( 'max-width', Math.floor( $( window ).width() - el.parent().offset().left ) + 'px' );
  //     }
  //   });
  // }

  /** Set grid dropdown widths */
  $( '.nav-item.dropdown' ).on( 'show.bs.dropdown', function() {
    let el = $( this );

    // Leave alone on small screens
    if ( !el.parents( '.collapse.show' ).length ) {

      // Grid Dropdown
      if ( el.children( '.pd-dropdown-grid' ).length ) {
        let grid = el.children( '.pd-dropdown-grid' );
        grid.removeAttr( 'style' );

        // Not full width
        if ( !grid.hasClass( 'pd-full-width-dropdown' ) && !$( 'html' ).hasClass( 'ua-trident' ) ) {
          let cols = el.find( '[class^="col-"]' );
          grid.css( 'word-break', 'break-all' );
          grid.css( 'width', ( grid.width() * cols.length ) + 'px' );

          // Full width (or IE)
        } else {
          let container = el.parents( 'nav' );

          // Check whether to match to container or full navbar
          if ( el.parents( 'nav .container' ).length ) {
            container = el.parents( 'nav .container' );
          }
          let widthInt = container.innerWidth() - parseInt( container.css( 'padding-left' ) );
          grid.css( 'width', widthInt + 'px' );
          grid.css( 'margin-left', ( -1 * ( el.offset().left - container.offset().left ) ) + 'px' );
        }
      }
    }
  });

});
